
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"48","viewBox":"0 96 960 960","width":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M683 816q-13 0-21.5-8.5T653 786q0-13 8.5-21.5T683 756h97L539 515 393 661q-5 5-10 7t-11 2q-6 0-11-2t-10-7L101 412q-9-8-8.5-21t9.5-22q9-9 21.5-9t21.5 9l226 227 146-146q5-5 10-7t11-2q6 0 11 2t10 7l262 262v-94q0-12 9-20.5t21-8.5q12 0 20.5 8.5T880 618v168q0 13-8.5 21.5T850 816H683z"}})])
          )
        }
      }
    